import log from 'salvo-lite/log'

class ProductFinder {
    constructor (components) {
        this._name = this.constructor.name
        this._elem = '[data-product-finder]'
        this._wrapper = '[data-product-finder-wrapper]'
        this._loading = '[data-product-finder-loading-results]'
        this._inputs = '[data-product-finder-value]'
        this._activeInputs = []
        this._stepBacks = '[data-product-finder-step-back]'
        this._steps = '[data-product-finder-step]'
        this._products = []
        this._results = {
            'template': {
                'source': document.querySelector('#productFinderResults'),
                'container': null,
                'header': null,
                'result': null,
                'footer': null
            },
            'append': document.querySelector('[data-product-finder-results-append]'),
            'html': {
                'addToCart': null,
                'all': null,
                'header': null,
                'results': [],
                'freeGift': null,
                'footer': null
            },
            'rendered': {
                'results': null
            }
        }
        this._attr = {
            'allActive': true,
            'hasFreeGift': false,
            'prefix': 'pf=',
            'currStep': 1,
            'currStepStr': '1',
            'currResult': 0,
            'delayTime': 750,
            'dataStep': 0,
            'endpoint': '',
            'activeTags': [],
            'query': '',
            'url': `${document.location.origin}/collections/product-finder/`,
            'end': false,
            'rendered': false,
            'toAdd': 0,
            'toLoad': 0,
            'loadCount': 0,
            'observer': {
                'config': {
                    'childList': true
                },
                'ref': null
            }
        }
    }

    onInit () {
        this._fetchTemplate()
        this._elem = document.querySelector(this._elem)
        this._wrapper = this._elem.querySelector(this._wrapper)
        this._loading = this._elem.querySelector(this._loading)
        this._inputs = this._elem.querySelectorAll(this._inputs)
        this._stepBacks = this._elem.querySelectorAll(this._stepBacks)
        this._steps = this._getSteps()
        this._wrapper.style.height = `${this._steps[0].container.scrollHeight}px`
        this._attachEvent()
        window.productFinder = this
        log.debug(this._name, 'Initiated', this)
    }

    _fetchTemplate () {
        let tElem = document.createElement('div')
        tElem.innerHTML = this._results.template.source.innerHTML
        this._results.template.source = tElem
        for (let key of Object.keys(this._results.template)) {
            if (key === 'source') continue
            this._results.template[key] = tElem.querySelector(`[data-results-${key}]`)
        }
    }

    _getSteps () {
        let retArr = []
        this._steps = this._elem.querySelectorAll(this._steps)
        for (let elem of this._steps) {
            let elems = elem.querySelectorAll('[data-product-finder-needs]')
            let needTags = []
            for (let needElem of elems) {
                let tArr = []
                let needElemDatas = needElem.dataset.productFinderNeeds.split('|')
                for (let needElemData of needElemDatas) {
                    tArr.push(needElemData.split('&'))
                }
                needTags.push(tArr)
            }
            retArr.push({
                'container': elem.parentElement,
                'activeElem': null,
                'elems': elems,
                'hiddenElems': elem.querySelectorAll('.product-finder__option.hide'),
                'needTags': needTags
            })
        }
        return retArr
    }

    _attachEvent () {
        for (let elem of this._inputs) {
            elem.addEventListener('click', e => {
                if (elem.checked) return false
                if (this._results.html.results.length > 0) {
                    this._results.html.results = []
                }
                for (let elem of this._inputs) {
                    elem.classList.remove('active')
                }
                elem.classList.add('active')
                this._addToActiveTags(elem.dataset.productFinderValue)
                if (this._attr.end) {
                    this._loadResults()
                    return false
                }
                this._steps[this._attr.dataStep].activeElem = elem
                this._goToNextStep()
            })
        }
        for (let elem of this._stepBacks) {
            elem.addEventListener('click', e => this._goToPreviousStep())
        }
    }

    _loadResults () {
        this._loading.classList.add('show')
        this._attr.query = this._makeQuery()
        this._attr.endpoint = `${this._attr.url}${this._attr.query}`
        this._makePromise('GET', this._attr.endpoint).then(resp => {
            resp = JSON.parse(resp)
            this._products = resp
            this._markProductsAsChecked()
            this._renderResults()
        })
    }

    _markProductsAsUnchecked () {
        for (let [index] of this._products.entries()) {
            if (!this._attr.rendered) break
            let resultChecker = this._results.html.results[index]
            if (!resultChecker) continue
            resultChecker = resultChecker.checker
            resultChecker.classList.remove('active')
            resultChecker.productFinder.active = false
        }
        this._attr.allActive = false
    }

    _markProductsAsChecked () {
        for (let [index] of this._products.entries()) {
            if (!this._attr.rendered) break
            let resultChecker = this._results.html.results[index]
            if (!resultChecker) continue
            resultChecker = resultChecker.checker
            resultChecker.classList.add('active')
            resultChecker.productFinder.active = true
        }
        this._attr.allActive = true
    }

    _buildFreeGift (elem) {
        elem.classList.add('is-free-gift')
        this._results.html.freeGift = elem
    }

    _buildResult (result) {
        let retObj = {}
        retObj.container = this._results.template.result.cloneNode(true)
        retObj.checker = retObj.container.querySelector('[data-result-checker]')
        retObj.checker.productFinder = {}
        retObj.checker.productFinder.active = true
        retObj.checker.productFinder.ref = result.variants[0].id

        let optionIndex = -1

        for (let [index, option] of result.options.entries()) {
            if (option !== 'Free Gift') continue
            retObj.checker.productFinder.potentiallyFree = true
            this._isFree = true
            optionIndex = index + 1
            break
        }

        if (retObj.checker.productFinder.potentiallyFree) {
            for (let variant of result.variants) {
                if (variant[`option${optionIndex}`] === 'Yes') {
                    retObj.checker.productFinder.ref = variant.id
                    continue
                }
                if (variant[`option${optionIndex}`] === 'No') {
                    retObj.checker.productFinder.notFree = variant.id
                    retObj.checker.productFinder.notFreePrice = variant.price
                    continue
                }
            }
        }

        let associatedResults = false
        let isFreeGift = false

        for (let tag of result.tags) {
            if (tag.indexOf('is-free-gift') !== -1) {
                associatedResults = tag.split(':')[1].split('|')
            }
        }

        if (associatedResults) {
            for (let associatedResult of associatedResults) {
                let associatedTags = associatedResult.split('&')
                for (let [index, associatedTag] of associatedTags.entries()) {
                    if (associatedTag !== this._attr.activeTags[index]) {
                        isFreeGift = false
                        break
                    }
                    isFreeGift = true
                }
                if (isFreeGift) break
            }
        }

        if (isFreeGift) {
            retObj.checker.productFinder.isFreeGift = isFreeGift
            this._buildFreeGift(retObj.container)
            this._attr.hasFreeGift = true
        } else {
            let tempFreeGift = retObj.container.querySelector('[data-result-free-gift]')
            tempFreeGift.parentElement.removeChild(tempFreeGift)
        }

        retObj.img = retObj.container.querySelector('[data-result-image]')
        retObj.title = retObj.container.querySelector('[data-result-title]')
        if (result.price) retObj.price = retObj.container.querySelector('[data-result-price]')
        if (!retObj.price) retObj.price = retObj.container.querySelector('[data-result-price-without-currency]')
        if (retObj.checker.productFinder.potentiallyFree) retObj.price = retObj.container.querySelector('[data-result-price]')
        retObj.variants = retObj.container.querySelector('[data-result-variants-container]')
        retObj.variant = retObj.container.querySelector('[data-result-variant]')
        let tempDescription = retObj.container.querySelector('[data-result-description]')
        if (result.featured_image) {
            this._attr.toLoad++
            retObj.img.alt = result.title
            retObj.img.src = result.featured_image
        } else {
            retObj.img.parentElement.removeChild(retObj.img)
        }
        retObj.title.innerHTML = result.title
        let priceWithoutCurrency = retObj.price.hasAttribute('data-result-price-without-currency')
        if (result.price && !priceWithoutCurrency) {
            retObj.price.innerHTML = this._formatMoney(result.price)
        } else {
            retObj.price.innerHTML = this._formatMoney(result.price, '{{amount_with_comma_separator}}')
        }
        if (retObj.checker.productFinder.potentiallyFree) retObj.price.innerHTML = this._formatMoney(retObj.checker.productFinder.notFreePrice)
        console.dir(retObj)
        this._buildVariants(retObj.variants, retObj.variant, result.variants, result.options)
        this._buildDescription(tempDescription, result.description)
        return retObj
    }

    _addToCartLogic () {
        if (this._attr.toAdd === 0) {
            this._redirectUser()
            return false
        }
        let result = this._results.html.results[this._attr.currResult]
        let checkerElem = result.checker
        if (checkerElem.productFinder.active) {
            this._addToCart(checkerElem)
        } else {
            this._attr.toAdd--
            this._attr.currResult++
            this._addToCartLogic()
        }
    }

    _addToCart (elem) {
        log.debug(this._name, 'Add To Cart', this)
        console.dir(elem)
        let data = {
            quantity: 1,
            id: elem.productFinder.ref
        }
        if (!this._isFree && elem.productFinder.notFree) {
            data.id = elem.productFinder.notFree
        }
        if (elem.productFinder.potentiallyFree && !this._results.html.freeGift) {
            data.id = elem.productFinder.notFree
        }
        if (elem.productFinder.isFreeGift && this._attr.allActive) {
            data.properties = {
                'free-gift': 'Free Gift',
                'ignore_pf_ids': this._getActiveIds()
            }
        }
        log.debug(this._name, 'LINE ITEM PROPERTIES', data)
        data = JSON.stringify(data)
        this._makePromise('POST', '/cart/add.js', data).then(resp => {
            this._attr.toAdd--
            this._attr.currResult++
            if (this._attr.toAdd !== 0) {
                this._addToCartLogic()
            } else {
                this._redirectUser()
            }
        })
    }

    _getActiveIds () {
        let retStr = []
        for (let product of this._products) {
            retStr.push(product.id)
        }
        return retStr.join('|')
    }

    _redirectUser () {
        window.location.href = '/cart'
    }

    _toggleAll (bool) {
        for (let elem of this._results.html.all) {
            if (bool) {
                elem.classList.add('active')
            } else {
                elem.classList.remove('active')
            }
        }
    }

    _checkerLogic (elem) {
        log.debug(this._name, 'CHECKER CLICKED!', this)
        elem.productFinder.active = !elem.productFinder.active
        elem.classList.toggle('active')
        if (elem.productFinder.active) {
            for (let result of this._results.html.results) {
                let checkerStatus = result.checker.productFinder.active
                if (checkerStatus) {
                    this._attr.allActive = true
                } else {
                    this._attr.allActive = false
                }
            }
        } else {
            this._attr.allActive = false
        }
        this._toggleAll(this._attr.allActive)
        if (this._results.html.freeGift) {
            this._checkFreeGift()
        }
    }

    _checkFreeGift () {
        log.debug(this._name, 'Checking Free Gift', this)
        this._attr.allActive = true
        for (let result of this._results.html.results) {
            let resultActive = result.checker.productFinder.active
            if (resultActive) {
                this._attr.allActive = true
                continue
            }
            this._attr.allActive = false
            break
        }
        if (this._attr.allActive) {
            this._results.html.freeGift.classList.add('is-free-gift')
            this._isFree = true
        } else {
            this._results.html.freeGift.classList.remove('is-free-gift')
            this._isFree = false
        }
    }

    _buildDescription (descriptionElem, description) {
        let tempElem = document.createElement('div')
        tempElem.innerHTML = description
        tempElem = tempElem.querySelector('p')
        tempElem.innerHTML = tempElem.innerHTML.replace('[', '')
        if (tempElem.innerHTML.indexOf(']') !== -1) {
            tempElem.innerHTML = tempElem.innerHTML.substr(0, tempElem.innerHTML.indexOf(']'))
        }
        descriptionElem.innerHTML = tempElem.innerHTML
    }

    _buildVariants (variantsContainer, variantElem, variantsArr, optionsArr) {
        let tempVariant = variantElem.cloneNode(true)
        variantsContainer.innerHTML = ''
        for (let variant of variantsArr) {
            let vTitle = variant.title.toLowerCase()
            if (vTitle === 'default title' || vTitle === 'no' || vTitle === 'yes') continue
            tempVariant.innerHTML = variant.title
            variantsContainer.appendChild(tempVariant)
        }
        return variantsContainer.innerHTML
    }

    _freeGiftSnippets () {
        let freeGiftElems = this._results.template.container.querySelectorAll('[data-result-free-gift]')
        for (let elem of freeGiftElems) {
            elem.parentElement.removeChild(elem)
        }
    }

    _renderResults () {
        this._results.template.container.innerHTML = ''
        this._results.html.header = this._results.template.header
        this._results.template.container.appendChild(this._results.html.header)
        for (let result of this._products) {
            let newResult = this._buildResult(result)
            this._results.html.results.push(newResult)
            this._results.template.container.appendChild(newResult.container)
        }
        this._results.html.footer = this._results.template.footer
        this._results.template.container.appendChild(this._results.html.footer)
        this._results.html.all = this._results.template.container.querySelectorAll('[data-results-all]')
        this._addEventListeners()
        if (!this._attr.hasFreeGift) this._freeGiftSnippets()
        this._results.append.appendChild(this._results.template.container)
        this._attr.rendered = true
        this._loading.classList.remove('show')
        this._attr.delayRef = requestAnimationFrame(ts => {
            this._delayAction(ts, 0, () => {
                window.scrollTo({
                    behavior: 'smooth',
                    top: this._results.append.offsetTop - 130
                })
            })
        })
    }

    _delayAction (currTime, startTime, func) {
        startTime = startTime || currTime
        let diff = currTime - startTime
        if (diff >= this._attr.delayTime) {
            func()
        } else {
            this._attr.delayRef = requestAnimationFrame(ts => {
                this._delayAction(ts, startTime, func)
            })
        }
    }

    _imgLogic (imgElem) {
        if (this._attr.loadCount !== this._attr.toLoad) return false
        this._results.append.classList.remove('no-results')
    }

    _manageAll () {
        for (let elem of this._results.html.all) {
            elem.classList.toggle('active')
        }
        if (this._attr.allActive) {
            this._markProductsAsUnchecked()
        } else {
            this._markProductsAsChecked()
        }
    }

    _addEventListeners () {
        this._results.html.addToCart = this._results.template.container.querySelectorAll('[data-results-add-to-cart]')
        for (let elem of this._results.html.all) {
            elem.addEventListener('click', e => this._manageAll())
        }
        for (let result of this._results.html.results) {
            result.checker.addEventListener('click', e => this._checkerLogic(result.checker))
            if (result.img.complete) {
                this._attr.loadCount++
                this._imgLogic(result.img)
            } else {
                result.img.addEventListener('load', e => {
                    this._attr.loadCount++
                    this._imgLogic(result.img)
                })
            }
        }
        for (let addToCart of this._results.html.addToCart) {
            addToCart.addEventListener('click', e => {
                this._attr.toAdd = this._results.html.results.length
                this._addToCartLogic()
            })
        }
    }

    _makePromise (method, url, data) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest()
            xhr.open(method, url)
            if (data) {
                xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
            }
            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.responseText)
                } else {
                    reject(xhr.statusText)
                }
            }
            xhr.onerror = () => reject(xhr.statusText)
            if (data) {
                xhr.send(data)
            } else {
                xhr.send()
            }
        })
    }

    _makeQuery () {
        let pathName = this._attr.activeTags.join(`+${this._attr.prefix}`)
        return `product-finder-product+${this._attr.prefix}${pathName}`
    }

    _goToPreviousStep () {
        this._steps[this._attr.dataStep].container.classList.remove('active')
        for (let elem of this._steps[this._attr.dataStep].hiddenElems) {
            if (elem.classList.contains('hide')) continue
            elem.classList.add('hide')
        }
        if (this._attr.end) {
            this._attr.activeTags.splice(this._attr.dataStep, 1)
            this._attr.end = false
        }
        this._attr.currStep--
        this._attr.currStepStr = this._attr.currStep + ''
        this._attr.dataStep--
        this._attr.activeTags.splice(this._attr.dataStep, 1)
        this._steps[this._attr.dataStep].container.classList.add('active')
        this._steps[this._attr.dataStep].activeElem.classList.remove('active')
        this._steps[this._attr.dataStep].activeElem = null
        this._wrapper.style.height = `${this._steps[this._attr.dataStep].container.scrollHeight}px`
    }

    _goToNextStep () {
        this._steps[this._attr.dataStep].container.classList.remove('active')
        this._attr.currStep++
        this._attr.currStepStr = this._attr.currStep + ''
        this._attr.dataStep++
        this._steps[this._attr.dataStep].container.classList.add('active')
        this._wrapper.style.height = `${this._steps[this._attr.dataStep].container.scrollHeight}px`
        this._attr.end = this._attr.currStep === this._steps.length
        this._checkNeedElems()
    }

    _checkNeedElems () {
        let step = this._steps[this._attr.dataStep]
        let elems = step.elems
        let checkTags = step.needTags
        let activeElems = []

        for (let [index, tagsToCheck] of checkTags.entries()) {
            for (let tagGroup of tagsToCheck) {
                let matchedTags = 0
                for (let tag of tagGroup) {
                    if (this._attr.activeTags.indexOf(tag) === -1) continue
                    matchedTags++
                }
                if (this._attr.activeTags.length === matchedTags) {
                    if (this._attr.currStep !== 1) {
                        activeElems.push(elems[index])
                    }
                    elems[index].classList.remove('hide')
                    break
                }
            }
        }

        if (this._attr.currStep !== 1) this._activeInputs.push(activeElems)
    }

    _addToActiveTags (val, index = this._attr.currStep - 1) {
        this._attr.activeTags[index] = val
    }

    _formatMoney (cents, format) {
        if (typeof cents === 'string') { cents = cents.replace('.', '') }
        var value = ''
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
        var formatString = (format || window.theme.moneyFormat)

        function defaultOption (opt, def) {
            return (typeof opt === 'undefined' ? def : opt)
        }

        function formatWithDelimiters (number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2)
            thousands = defaultOption(thousands, ',')
            decimal = defaultOption(decimal, '.')

            if (isNaN(number) || number == null) { return 0 }

            number = (number / 100.0).toFixed(precision)

            var parts = number.split('.')
            var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
            var cents = parts[1] ? (decimal + parts[1]) : ''

            return dollars + cents
        }

        switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2)
            break
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0)
            break
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',')
            break
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',')
            break
        }

        return formatString.replace(placeholderRegex, value)
    }
}

export default ProductFinder



// WEBPACK FOOTER //
// ./src/scripts/pages/PageProductFinder.js